import { PAGES } from '@/consts';
import { Stocks } from '@/entities/stocks';
import { StocksDataProps } from '../components/popups/StocksFormPopup/StocksFormPopup';
import { axiosAPI } from './axios-instance';
import { ApiRequestFnParams, ApiResponse } from './lib/types';

export type ApiReviewsRequest = {
    page: PAGES;
};
export type ApiStocksResponse = ApiResponse<
    {
        id: number;
        slug: string;
        name: string;
        description?: string;
        form_description?: string;
        duration: number;
    }[]
>;
export type ApiStocksRequest = ApiResponse<Stocks[]>;

const transformApiResponse = (response: ApiStocksResponse): ApiStocksRequest => {
    return {
        ...response,
        data: (response.data ?? []).map((item) => ({
            title: item.name,
            description: item.description || '',
            formDescription: item.form_description || '',
            timeDuration: item.duration || 14,
        })),
    };
};

export const getStocks = ({ params }: ApiRequestFnParams<ApiReviewsRequest> = {}): Promise<ApiStocksRequest> =>
    axiosAPI.get<ApiStocksResponse>('/v1/popups', { params }).then((res) => {
        return transformApiResponse(res.data);
    });
